/**
 * Units a `propertyType` encodes — `UNITS_BY_PROPERTY_TYPE` in the backend's
 * eastview-os app/models/pipeline.py, verbatim. Multifamily / Mixed-Use /
 * Commercial / Other carry no count (`null`): those are the only types whose
 * unit count is entered by hand.
 *
 * The DSCR quick-price input (`DscrQuickPriceInput`) applies the same lookup
 * server-side and OVERRIDES a client `unitCount` that disagrees with an
 * enumerated type, so the sizers send `propertyType` and show the derived count
 * read-only rather than asking for a number the backend would replace.
 */
export const UNITS_BY_PROPERTY_TYPE = {
  SFR: 1,
  Condo: 1,
  Townhome: 1,
  "Planned Unit Development (PUD)": 1,
  "Non-Warrantable Condo": 1,
  "2-unit": 2,
  "3-unit": 3,
  "4-unit": 4,
  "5-unit": 5,
  "6-unit": 6,
  "7-unit": 7,
  "8-unit": 8,
};

/** Units the type encodes, or null when the type carries no count (manual entry). */
export const unitsForPropertyType = (propertyType) =>
  propertyType ? (UNITS_BY_PROPERTY_TYPE[propertyType] ?? null) : null;
